import React from 'react'
import { Navigate } from 'react-router-dom'
import { RouterLayout } from './layout'
import SignIn from '../pages/signin'
import SignUp from '../pages/signup'
import signUpSuccess from '../pages/signup/success'
import verifySuccess from '../pages/signup/verifySuccess'
import verifyFailure from '../pages/signup/verifyFailure'
import ForgotPassword from '../pages/forgotPassword'
import ForgotPasswordSuccess from '../pages/forgotPassword/success'
import ResetPassword from '../pages/resetPassword'
import ResetPasswordSuccess from '../pages/resetPassword/success'
import Home from '../pages/home'
import HomeV2 from '../pages/home/homeV2'
import Onboarding from '../pages/onboarding'
import Setting from '../pages/setting'
import ResendEmailConfirm from "../pages/resendEmailConfirm";
import FAQs from "../pages/faqs";

const Routes = [
  {
    path: "*",
    element: <Navigate to="/signin" replace />,
  },
  {
    path: "/signin",
    element: RouterLayout(SignIn),
  },
  {
    path: "/signup",
    element: RouterLayout(SignUp),
  },
  {
    path: "/signup/success",
    element: RouterLayout(signUpSuccess),
  },
  {
    path: "/signup/verify-success",
    element: RouterLayout(verifySuccess),
  },
  {
    path: "/signup/verify-failure",
    element: RouterLayout(verifyFailure),
  },
  {
    path: "/forgot-password",
    element: RouterLayout(ForgotPassword),
  },
  {
    path: "/forgot-password/success",
    element: RouterLayout(ForgotPasswordSuccess),
  },
  {
    path: "/reset-password",
    element: RouterLayout(ResetPassword),
  },
  {
    path: "/reset-password/success",
    element: RouterLayout(ResetPasswordSuccess),
  },
  {
    path: "/onboarding",
    element: RouterLayout(Onboarding),
  },
  {
    path: "/setting",
    element: RouterLayout(Setting),
  },
  {
    path: "/resend-email-confirmation",
    element: RouterLayout(ResendEmailConfirm),
  },
  {
    path: "/faqs",
    element: RouterLayout(FAQs),
  },
  {
    path: "/",
    element: RouterLayout(Home),
  },
  {
    path: "/home-v2",
    element: RouterLayout(HomeV2),
  },
];

export default Routes
